import type { TemplateOnlyComponent } from '@ember/component/template-only';

export default <template>
  (sollte niemals angezeigt werden, da die Route direkt weiterleitet)
</template> satisfies TemplateOnlyComponent<{
  Args: { model: unknown; controller: unknown };
}>;
